import { Injectable } from '@angular/core';
import Axios from 'axios';
import { SliderDto } from '../dtos/sliderDto';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment'
import { StaticPageCreateDto } from '../dtos/staticPage/staticPageCreateDto';
import { StaticPageUpdateDto } from '../dtos/staticPage/staticPageUpdateDto';
import { PageType } from '../enums/pageType';


@Injectable({
    providedIn: 'root',
})
export class SliderService {
 
      constructor(private http: HttpClient) { }
      
      public apiUrl = `${environment.apiUrl}/AdminDatas/`;
    
    private getHeaders() {
        const token = sessionStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }

    async getSliders(): Promise<SliderDto[]> {
        const { data } = await Axios.get(`${this.apiUrl}getSlider`, {
            headers: this.getHeaders()
        });
        return data;
    }

    async saveSliders(sliders: SliderDto[]): Promise<void> {
        await Axios.post(`${this.apiUrl}saveSlider`, sliders, {
            headers: this.getHeaders()
        });
    }
}